import React from "react";
import { Box, Text, Image, Button, HStack, VStack, IconButton  } from "@chakra-ui/react";
import { FaPlus, FaMinus, FaTrash } from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";
import { useProducts } from "./ProductContext";
import { useNavigate } from "react-router-dom";

const Cart = () => {
    const { cartItems, addToCart, removeFromCart, decreaseQuantity } = useProducts();

    // Beregn totalpris og MVA
    const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
    const vat = subtotal * 0.25; // 25% MVA
    const total = subtotal + vat;
    const navigate = useNavigate();

    return (
        <Box maxW="900px" mx="auto" py={10}>
            <Text fontSize="3xl" fontWeight="bold" textAlign="center" mb={6}>Handlekurv</Text>

            {cartItems.length === 0 ? (
                <Text textAlign="center">Handlekurven er tom.</Text>
            ) : (
                <>
                    {/* Produktliste */}
                    {cartItems.map((item) => (
                        <Box key={item.id} p={4} bg="white" borderRadius="md" boxShadow="md" mb={4}>
                            <HStack spacing={4} align="center">
                                <Image src={item.imageUrl} boxSize="80px" borderRadius="md" />
                                <Text flex="1" fontWeight="bold">{item.name}</Text>
                                <Text fontWeight="bold">kr {item.price.toFixed(2)}</Text>

                                {/* Antall-knapper */}
                                <HStack>
                                    <IconButton size="sm" icon={<FaMinus />} onClick={() => decreaseQuantity(item.id)} />
                                    <Text>{item.quantity}</Text>
                                    <IconButton size="sm" icon={<FaPlus />} onClick={() => addToCart(item)} />
                                </HStack>

                                <Text fontWeight="bold">kr {(item.price * item.quantity).toFixed(2)}</Text>

                                {/* Slett produkt */}
                                <IconButton size="sm" icon={<FaTrash />} colorScheme="red" onClick={() => removeFromCart(item.id)} />
                            </HStack>
                        </Box>
                    ))}

                    {/* Totalsum */}
                    <VStack align="flex-end" spacing={2} mt={6}>
                        <Text>inkl MVA: <b>kr {total.toFixed(2)}</b></Text>
                        <Text>eksl MVA: kr {subtotal.toFixed(2)}</Text>
                        <Text>MVA 25%: kr {vat.toFixed(2)}</Text>
                        <Text fontSize="xl" fontWeight="bold">TOTAL: kr {total.toFixed(2)}</Text>
                    </VStack>

                    {/* Handle videre og Checkout-knapp */}
                    <HStack mt={6} justifyContent="space-between">
                    <RouterLink to="/portfolio">
                        <Button variant="outline" colorScheme="teal" mb={4}>
                          ← Fortsett å handle
                        </Button>
                    </RouterLink>

                    <Button colorScheme="green" size="lg" onClick={() => navigate("/checkout")}>
                      Sjekk ut
                    </Button>
                    </HStack>
                </>
            )}
        </Box>
    );
};


export default Cart;
